module.exports = __webpack_public_path__ + "img/cover6-1920.740dc236.jpg";